var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChristmasLights = function SvgChristmasLights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.703 2.18a31.24 31.24 0 0 0 21.094 0M5.338 8.99l-2.73-.346.174-1.365a1.375 1.375 0 0 1 1.537-1.192h0a1.375 1.375 0 0 1 1.192 1.538z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.186 17.003c-.469.455-.743.837-1.346.76s-.766-.507-1.115-1.075a6.6 6.6 0 0 1 .777-8.063h0L5.444 9h0a6.604 6.604 0 0 1-1.258 8.003m7.981-6.569H9.415V9.06a1.375 1.375 0 0 1 1.377-1.372h0a1.375 1.375 0 0 1 1.375 1.376zm-.135 8.096c-.413.51-.632.923-1.24.923s-.824-.407-1.24-.923a6.6 6.6 0 0 1-.243-8.096h2.965a6.604 6.604 0 0 1-.242 8.096m4.273-9.54 2.726-.346-.172-1.365a1.375 1.375 0 0 0-1.538-1.192h0a1.376 1.376 0 0 0-1.192 1.538z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.456 17.003c.475.455.744.837 1.347.76s.765-.507 1.114-1.072a6.6 6.6 0 0 0-.777-8.062h0l-2.94.375h0a6.604 6.604 0 0 0 1.256 8zm-6.664-9.319V4.015M4.32 6.087l.37-2.781m12.634 2.781-.408-2.601"
  })));
};
export default SvgChristmasLights;